(function () {
  function initBowlRotation() {
    var bowl = document.querySelector('[class*="__fueled_bowl"] img');
    if (!bowl) return;

    var rotation = 0;
    var lastScrollY = window.scrollY;

    window.addEventListener('scroll', function () {
      var delta = window.scrollY - lastScrollY;
      lastScrollY = window.scrollY;
      rotation += delta * 0.12;
      bowl.style.transform = 'rotate(' + rotation + 'deg)';
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBowlRotation);
  } else {
    initBowlRotation();
  }
})();
